import React from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import ScanResults from "../../components/ScanDetails/ScanDetails";


const scanDetails = (props) => {
    return (
            <div className="wrapper">
                <Breadcrumbs searchPath={props.location.search} />
                <ScanResults/>
            </div>
    )
};

export default scanDetails;



// WEBPACK FOOTER //
// ./src/pages/manage/ScanDetails.js